import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';

export interface DialogData {
  price: string;

}

@Component({
  selector: 'app-open-dialog-confirm-update-booking',
  templateUrl: './open-dialog-confirm-update-booking.component.html',
  styleUrls: ['./open-dialog-confirm-update-booking.component.scss']
})
export class OpenDialogConfirmUpdateBookingComponent implements OnInit {

  checkPriceForm: UntypedFormGroup;
  isCheck = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<OpenDialogConfirmUpdateBookingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  checkValue(): void {
    this.isCheck = this.f.price.value && (this.f.price.value === this.data.price) ? true : false;
  }

  get f() {
    return this.checkPriceForm.controls;
  }

  private initForm(): void {
    this.checkPriceForm = this.formBuilder.group({
      price: ['']
    });
  }

}
